<!--
  ~ Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<br/>
<h1 class="page-header">Consolidated RPO Matrix</h1>
<br/>
@if (permission()) {
    <table class="files-input">
        <tr>
            <td>
                <app-file-upload-card (filesSelected)="onFilesSelected($event, 'harnessMatrixFiles')"
                                      [header]="'Harness Matrix:'" [multiple]="true"
                                      [subheader]="'*Select 2 or more Harness Matrix files'"></app-file-upload-card>
            </td>
        </tr>
        <tr>
            <td>
                <div class="buttons">
                    <span [pTooltip]="generateCrm2DisabledReason()" tooltipPosition="top" style="display: inline-block; vertical-align: middle">
                        <p-button label="Generate Consolidated RPO Matrix" icon="pi pi-check" class="gm-btn-primary mr-2"
                                  [disabled]="!(harnessMatrixFiles?.length >= 2) || !permission()"
                                  (click)="generateCrm2()">
                        </p-button>
                    </span>
                </div>
            </td>
        </tr>
    </table>
}

@if (progress() > 0) {
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
}
@for (msg of crm2Messages; track $index) {
    <p-message [severity]="msg.severity" [text]="msg.detail" [closable]="true"></p-message>
}
